import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from '../src/assets/locales/en/translation.json';
import translationBM from '../src/assets/locales/bm/translation.json';

const resources = {
    en: {
        translation: translationEN
    },
    bm: {
        translation: translationBM
    }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    debug: false,
    fallbackLng: 'en'
  });


export default i18n;